<template>
    <QuestionAbstract>
  
      <template #title>
        {{ formattedQuestion }}
      </template>
  
      <template #content>
        <div class="question-choice">
          <!-- render each option -->
          <v-checkbox
            v-for="option in options"
            :key="option"
            hide-details
            color="color1"
            v-model="answer"
            :label="option"
            :value="option"
          />
  
          <!-- only show this when "Other" is checked -->
          <div v-if="answer.includes('Other')" class="other-field">
            <v-text-field
              hide-details
              v-model="otherText"
              label="Please specify"
              @input="handleAnswer"
            />
          </div>
        </div>
      </template>
  
    </QuestionAbstract>
  </template>
  
  <script>
  import QuestionAbstract from '@/components/survey/question/QuestionAbstract.vue'
  
  export default {
    name: 'QuestionChoice',
    components: { QuestionAbstract },
    props: {
      index:   { type: Number, required: true },
      question:{ type: String, required: true },
      options: {
        type: Array,
        default: () => ['Yes', 'No', 'Other']
      }
    },
    data() {
      return {
        answer:    [],    // array of selected options
        otherText: ''     // free-text for "Other"
      }
    },
    computed: {
      formattedQuestion() {
        return `${this.index + 1}. ${this.question}`
      }
    },
    watch: {
      // whenever answer array changes, re-emit
      answer(newVal, oldVal) {
        if (newVal !== oldVal) this.handleAnswer()
      }
    },
    emits: ['answer'],
    methods: {
      handleAnswer() {
        // clone the array so we don't mutate v-model directly
        const final = [...this.answer]
  
        // if "Other" is in there and user has typed something, swap it out
        const i = final.indexOf('Other')
        if (i !== -1 && this.otherText.trim()) {
          final.splice(i, 1, this.otherText.trim())
        }
  
        // emit index + the transformed answers
        this.$emit('answer', this.index, final)
      }
    }
  }
  </script>
  
  <style scoped>
  .question-choice {
    width: 100%;
  }
  
  .question-choice .v-radio {
    margin-right: 10px;
  }
  
  .other-field {
    margin-top: 8px;
  }
  </style>
  